<template>
  <b-col class="card-512 mt-3" lg="12" md="6" sm="12" >
    <b-card id="card-c512" class="zoom-512-img">
      <b-row>
        <b-col>
          <img :src="image" :alt="alt" class="w-100 zoom-512 rounded"/>
          <div class="position-relative mr-1">
            <slot name="pr-1"></slot>
          </div>
        </b-col>
      </b-row>

      <b-row class="mr-1 ">
        <b-col>
          <a href="#" class="text-secondary text-decoration-none">
            <slot name="p-1"></slot>
          </a>
        </b-col>

        <b-col lg="12">
          <b-row>
            <slot name="p-2"></slot>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </b-col>
</template>

<script>
export default {
  props: ["image", "alt"],
};
</script>

<style>
.card-512 .button-512 {
  background-color: var(--light-red);
  color: var(--light);
  width: 120px;
  padding: 10px;
  font-weight: bold;
  border: none;
  position: relative;
  margin-bottom: 30px;
  margin-right: 10px;
}

.card-512 .button-512:hover {
  color: var(--light);
  background-color: var(--light-orange);
}

.card-512 .text-512-p:hover {
  color: var(--light-red);
}

.card-512 .color-link-512 {
  color: var(--light-red);
}

.card-512 .zoom-512 {
  transition: 0.7s;
  overflow: hidden;
}

.card-512 .zoom-512:hover {
  transform: scale(1.1);
  transition: 0.7s;
}

.card-512 .card-body {
  padding: 0;
  overflow: hidden;
}
</style>
